import React, {
  ComponentType,
  SVGProps,
} from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import MailOutlineIcon from '@mui/icons-material/MailOutlineRounded';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import type {
  IconKey,
} from 'views/EMR/components/PCC/Walkthrough/types';

type IconProps = SVGProps<SVGSVGElement> & {
  className?: string;
};

type IconComponent = ComponentType<IconProps>;

const iconMap: Record<IconKey, IconComponent> = {
  check: CheckIcon as IconComponent,
  shield: ShieldOutlinedIcon as IconComponent,
  phone: PhoneOutlinedIcon as IconComponent,
  calendar: CalendarTodayOutlinedIcon as IconComponent,
  info: InfoOutlinedIcon as IconComponent,
  warning: WarningAmberOutlinedIcon as IconComponent,
  user: PersonOutlineOutlinedIcon as IconComponent,
  document: DescriptionOutlinedIcon as IconComponent,
  exit: ExitToAppOutlinedIcon as IconComponent,
  arrowRight: ArrowForwardIcon as IconComponent,
  arrowLeft: ArrowBackIcon as IconComponent,
  close: CloseIcon as IconComponent,
  mail: MailOutlineIcon as IconComponent,
};

type WalkthroughIconProps = {
  iconKey: IconKey;
  className?: string;
};

export default function WalkthroughIcon({
  iconKey,
  className,
}: WalkthroughIconProps) {
  const Icon = iconMap[iconKey];

  return (
    <Icon
      aria-hidden="true"
      className={className}
      focusable="false"
    />
  );
}
